import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    height: -webkit-fill-available;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: center;
      flex-direction: column;
    }
  `}
`;

export const ButtonBackWrapper = styled.div`
  position: absolute;
  left: 26px;
  top: 30px;
  z-index: 10;
`;

export const PromoPanel = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-image: ${theme.v2.colors.gradient.tertiary};
    background-size: cover;
    border-radius: 0 120px 0 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 40px;
    padding-top: 120px;
    position: relative;
    width: 45%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: center;
      border-radius: 0 0 120px 0;
      padding: 0;
      padding-top: 0;
      width: 100%;
    }
  `};
`;

export const PromoPanelInner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
`;

export const PromoTitleContainer = styled.div`
  ${({ theme }) => css`
    margin: 0 0 32px;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
      padding: 28px 0;
    }
  `}
`;

export const PromoTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;

    @media (min-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
    
    @media (min-width: ${theme.v2.breakpoints.lg}) {
      font-size: 28px;
    }
  `};
`;

export const PromoImage = styled.img`
  ${({ theme }) => css`
    max-width: 715px;
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `};
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    bottom: -183px;
    left: -134px;
    max-width: 410px;
    position: absolute;
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const FormContainer = styled.div`
  ${({ theme }) => css`
    max-width: 600px;
    overflow-y: auto;
    padding: 24px 20px;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
      padding: 48px 40px;
      overflow: auto;
    }
  `};
`;

export const TabsWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: inline-flex;
    gap: 48px;
    margin-bottom: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: flex;
      gap: 16px;
      justify-content: space-between;
    }
  `};
`;

export const TabItem = styled.div`
  ${({ theme, $active }) => css`
    align-items: center;
    color: ${$active ? theme.v2.colors.brand.primaryDark : theme.v2.colors.neutral.highMedium};
    display: flex;
    flex-direction: column;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${$active ? theme.v2.font.weights.medium : theme.v2.font.weights.regular};
    gap: 12px;
    position: relative;
    white-space: nowrap;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxxs};
    }
  `};
`;

export const IconCircleCheck = styled.img`
  height: 24px;
  width: 24px;
`;

export const TabIndex = styled.div`
  ${({ theme, $active, $completed }) => css`
    background: ${$active ? theme.v2.colors.gradient.tertiary : theme.v2.colors.white.primary};
    border: ${$active ? '0' : `1px solid ${theme.v2.colors.neutral.highMedium}`};
    border-radius: 50%;
    color: ${$active ? theme.v2.colors.white.primary : theme.v2.colors.neutral.highMedium};
    display: inline-block;
    font-size: 14px;
    height: 24px;
    line-height: ${$active ? '24px' : '22px'};
    position: relative;
    text-align: center;
    width: 24px;
    z-index: 2;

    ${$completed && css`
      border: 0;
      line-height: 24px;
    `}
  `}
`;

export const TabLabel = styled.div`
  line-height: 1.5;
`;

export const TabLine = styled.div`
  ${({ theme, $active, $isLastTab }) => css`
    background: ${$active ? theme.v2.colors.gradient.tertiary : theme.v2.colors.neutral.highMedium};
    height: 2px;
    left: calc(50% + 12px);
    position: absolute;
    top: 11px;
    
    ${$isLastTab && css`
      display: none;
    `}
  `}
`;

export const Content = styled.div``;

export const FadeContent = styled.div`
  ${({ $fadeState }) => css`
    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    ${$fadeState === 'fade-in' && css`
      opacity: 1;
    `}

    ${$fadeState === 'fade-out' && css`
      opacity: 0;
    `}
  `};
`;
